import axios from 'axios';
import router from './router';
import routerpath from './router/routerpath';

const apiBaseURL = process.env.VUE_APP_API_URL || (window.location.hostname === 'localhost' ? 'https://backdev.smart2doc.com.br/' : 'https://backend.smart2doc.com.br/');

const getAPI = axios.create({
  baseURL: apiBaseURL + routerpath,
  timeout: 600000
});
const AxiosAPI = axios.create({
  baseURL: apiBaseURL + routerpath,
  timeout: 600000
});

/* interceptors */
getAPI.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      router.push({ name: 'Login' });
    }

    // return Error object with Promise
    return Promise.reject(error);
  }
);

export { getAPI, AxiosAPI };
